import { render } from "./ReferralCouponsView.vue?vue&type=template&id=8aa46d30&scoped=true"
import script from "./ReferralCouponsView.vue?vue&type=script&lang=js"
export * from "./ReferralCouponsView.vue?vue&type=script&lang=js"

import "./ReferralCouponsView.vue?vue&type=style&index=0&id=8aa46d30&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aa46d30"]])

export default __exports__